import React from 'react';
import PropTypes from 'prop-types';
import Dropzone from 'react-dropzone';
import { Row, Col, Button, Input } from 'react-bootstrap';
import { I18n } from 'react-redux-i18n';

const propTypes = {
  dependentValues: PropTypes.shape({
    Name: PropTypes.string,
    Description: PropTypes.string,
    Index: PropTypes.number,
  }),
  showImageOnly: PropTypes.bool,
  renderImage: PropTypes.func,
  onRowValueChange: PropTypes.func,
  onDrop: PropTypes.func,
};

const defaultProps = {
  showImageOnly: true,
  dependentValues: {},
  renderImage: () => {},
  onRowValueChange: () => {},
  onDrop: () => {},
};

const Category2ImageFormatter = React.createClass({
  getInitialState() {
    return {
      name: '',
      description: '',
    };
  },
  componentWillMount() {
    const { Name, Description } = this.props.dependentValues;
    const name = Name || '';
    const description = Description || '';
    this.setState({ name, description });
  },
  componentWillReceiveProps(nextProps) {
    if (nextProps.dependentValues && nextProps.dependentValues !== this.props.dependentValues) {
      const { Name, Description } = nextProps.dependentValues;
      const name = Name || '';
      const description = Description || '';
      this.setState({ name, description });
    }
  },
  onChange(event, field) {
    this.setState({ [field]: event.target.value });
  },
  render() {
    const { Index } = this.props.dependentValues;
    return (
      <div className={!this.props.showImageOnly ? 'category2-thumbnail-cell' : 'group-thumbnail-cell'}>
        <div id="image-container">
          { this.props.renderImage(Index) }
        </div>
        <Dropzone
          onDrop={this.props.onDrop.bind(Index, this)}
          className="image-dropzone"
          accept="image/*"
        >
          <Row>
            <Col xs={12}>
              <Button
                id="dropzone-button"
                bsStyle="primary"
                type="button"
              >
                <em className="fa fa-plus" />
              </Button>
            </Col>
          </Row>
        </Dropzone>
        <div>
          {
            !this.props.showImageOnly
            && (
              <div>
                <Row>
                  <label htmlFor="name">
                    <Input
                      type="text"
                      name="name"
                      placeholder={I18n.t('name')}
                      value={this.state.name}
                      onChange={event => this.onChange(event, event.target.name)}
                      onBlur={event => this.props.onRowValueChange(event, this.props.dependentValues, 'Name')}
                    />
                  </label>
                </Row>
                <Row>
                  <label htmlFor="description">
                    <Input
                      type="text"
                      name="description"
                      placeholder={I18n.t('description')}
                      value={this.state.description}
                      onChange={event => this.onChange(event, event.target.name)}
                      onBlur={event => this.props.onRowValueChange(event, this.props.dependentValues, 'Description')}
                    />
                  </label>
                </Row>
              </div>
            )
          }
        </div>
      </div>
    );
  },
});

Category2ImageFormatter.propTypes = propTypes;
Category2ImageFormatter.defaultProps = defaultProps;

export default Category2ImageFormatter;



// WEBPACK FOOTER //
// ./master/jsx/components/Common/ImageFormatter.jsx